import React from 'react';
import classNames from 'classnames';
import moment from 'moment/moment';

import css from './RelatedTransactionsSection.css';

const ServiceFeeTransaction = ({intl, statusClass, statusText, createdAt}) => {
  return (
    <>
      <span className={css.rentalDates}>
        {intl.formatMessage({ id: "ServiceFeeTransaction.serviceFee" })}
      </span>
      <span className={classNames(statusClass, css.status)}>
        {`${intl.formatMessage({ id: statusText })} `}
      </span>
      <span className={css.createdDate}>
        {moment(createdAt).format("DD MMM YYYY HH:mm")}
      </span>
    </>
  )
}

export default ServiceFeeTransaction;
